import React, { useEffect, useState } from 'react'
import apiClient from 'services/axios'
import { arrayConverter } from 'services/utils'

const Thumbnail = ({ imageUrl }) => {
  const [buffer, setBuffer] = useState([])
  useEffect(() => {
    apiClient
      .get(`${process.env.REACT_APP_BASE_URL}/s3${imageUrl}`)
      .then((response) => {
        if (response.data) {
          setBuffer(arrayConverter(response.data.data.data))
        }
      })
      .catch((error) => {
        console.log(error)
      })

    // need to clean redux or api call
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <img
      src={`data:image/jpeg;base64,${buffer}`}
      width="80%"
      height="100%"
      alt="thumbnail"
      className="thumbnails"
    />
  )
}

export default Thumbnail
